import { action, observable } from 'mobx';
import apiCaller from '../../utils/api-caller';
import { v4 } from 'uuid';

class CmsDevaranaStore {
  @observable data = [];
  @observable images = [];

  @observable devaranas = [];
  @observable devarana = null;

  @observable selecteddevarana = null;
  @observable selectedimages = [];

  @observable showModal = false;
  @observable modalTitle = '';

  @observable updateLoading = false;

  @action getAll() {
    return apiCaller.CmsDevaranas.get().then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.data = resp.data;
        }
      }
    })
  }

  @action getAllByLanguage() {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsDevaranas.getByLanguageCode(languageCode).then(resp => {
      if (resp) {
        this.devaranas = resp;
      }
    })
  }

  @action getByIdAndLanguage(id) {
    const languageCode = window.localStorage.getItem('lang') || 'en';
    return apiCaller.CmsDevaranas.getByIdAndLanguageCode(id, languageCode).then(resp => {
      if (resp) {
        this.selecteddevarana = resp;
        this.selectedimages = [];
        if (this.selecteddevarana.bannerUrl) {
          try {
            let imagesJson = JSON.parse(this.selecteddevarana.bannerUrl);
            imagesJson.map(imageJson => {
              return imageJson.isLoading = false;
            });
            this.selectedimages = imagesJson;
          } catch {
            this.selectedimages.push({
              id: v4(),
              url: this.selecteddevarana.bannerUrl,
              isLoading: false
            });
          }
        }
      }
    })
  }

  @action getDataById(id) {
    this.modalTitle = 'Update Devarana Wellness';
    return apiCaller.CmsDevaranas.getById(id).then(resp => {
      if (!resp.isError) {
        if (resp.data) {
          this.images = [];
          this.devarana = resp.data;

          if (this.devarana.bannerUrl) {
            try {
              let imagesJson = JSON.parse(this.devarana.bannerUrl);
              imagesJson.map(imageJson => {
                return imageJson.isLoading = false;
              });
              this.images = imagesJson;
            } catch {
              this.images.push({
                id: v4(),
                url: this.devarana.bannerUrl,
                isLoading: false
              });
            }
          }

          this.images.push({
            id: v4(),
            url: '',
            isLoading: false
          });

          this.showModal = true;
        }
      }
    })
  }

  @action initCreate(languages) {
    this.modalTitle = 'Add Devarana Wellness';
    this.devarana = {
      'id': 0,
      'bannerUrl': '',
      'sort': 1,
      'devaranaLanguages': []
    };

    languages.map(language => {
      this.devarana.devaranaLanguages.push({
        'id': 0,
        'devaranaId': 0,
        'languageId': language.id,
        'title': '',
        'briefDescription': '',
        'description': ''
      });

      return language;
    })

    this.images = [{
      id: v4(),
      url: '',
      isLoading: false
    }];

    this.showModal = true;
  }

  @action create() {
    this.updateLoading = true;

    this.devarana.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));
    return apiCaller.CmsDevaranas.create(this.devarana);
  }

  @action update() {
    this.updateLoading = true;

    this.devarana.bannerUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));
    return apiCaller.CmsDevaranas.update(this.devarana.id, this.devarana);
  }

  @action delete(id) {
    return apiCaller.CmsDevaranas.delete(id);
  }

  @action cancel() {
    this.getData();
  }

  @action setsort(value) {
    this.devarana.sort = value;
  }

  @action settitle(langId, value) {
    let lang = this.devarana.devaranaLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.title = value;
    }
  }

  @action setbriefDescription(langId, value) {
    let lang = this.devarana.devaranaLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.briefDescription = value;
    }
  }

  @action setdescription(langId, value) {
    let lang = this.devarana.devaranaLanguages.find(fi => fi.languageId === langId);
    if (lang) {
      lang.description = value;
    }
  }

  @action setImageUrlById(id, value) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.url = value;
    }

    let blankImage = this.images.find(fi => fi.url === '');
    if (!blankImage) {
      this.images.push({
        id: v4(),
        url: '',
        isLoading: false
      });
    }
  }

  @action setImageIsLoadingById(id, isLoading) {
    let image = this.images.find(fi => fi.id === id);
    if (image) {
      image.isLoading = isLoading;
    }
  }

  @action removeImageById(id) {
    this.images = this.images.filter(fi => fi.id !== id);
  }

  @action setdevarana(value) {
    this.devarana = value;
  }

  @action setupdateLoading(value) {
    this.updateLoading = value;
  }

  @action setshowModal(value) {
    this.showModal = value
  }

  @action resetData() {
    this.devarana = null;

    this.selecteddevarana = null;
    this.selectedimages = [];
  }
}

export default new CmsDevaranaStore();